/**
 * Detects whether the app is being loaded by our prerender script (Puppeteer
 * headless Chrome via scripts/prerender.cjs) rather than a real user.
 *
 * Used to skip analytics / error-tracking SDKs during prerender so:
 *   1. Puppeteer's `networkidle0` wait can actually resolve (no long-lived
 *      session-replay/decide/flush requests keeping the network busy).
 *   2. Analytics data isn't polluted by CI page hits.
 */
export function isPrerender(): boolean {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }

  // Explicit opt-in via query param (set by scripts/prerender.cjs).
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get("prerender") === "1") return true;
  } catch {
    // Ignore — fall through to UA check.
  }

  // Fallback: headless Chrome user agent (Puppeteer default).
  const ua = navigator.userAgent || "";
  return /HeadlessChrome/i.test(ua);
}
